import { NgxEditorModule } from 'ngx-editor';

export const NgxEditorConfig = NgxEditorModule.forRoot({
  locals: {
    // menu
    bold: 'Pogrubienie',
    italic: 'Kursywa',
    code: 'Kod',
    blockquote: 'Cytat',
    underline: 'Podkreślenie',
    strike: 'Przekreślenie',
    bullet_list: 'Lista punktowana',
    ordered_list: 'Lista numerowana',
    heading: 'Nagłówki',
    h1: 'Nagłówek 1',
    h2: 'Nagłówek 2',
    h3: 'Nagłówek 3',
    h4: 'Nagłówek 4',
    h5: 'Nagłówek 5',
    h6: 'Nagłówek 6',
    align_left: 'Wyrównaj do lewej',
    align_center: 'Wyrównaj do środka',
    align_right: 'Wyrównaj do prawej',
    align_justify: 'Wyjustuj',
    text_color: 'Kolor tekstu',
    background_color: 'Kolor tła',

    // popups, forms, others
    url: 'Adres URL',
    text: 'Tekst',
    openInNewTab: 'Otwórz w nowej karcie',
    insert: 'Wstaw',
    altText: 'Tekst alternatywny',
    title: 'Tytuł',
    remove: 'Usuń',
    enterValidUrl: 'Wprowadź poprawny adres URL',
    required: 'To pole jest wymagane',
  },
});
